import { Component } from '@angular/core';
import { RouterOutlet } from "@angular/router";
import { ChromelessService } from '../../core/services/chromeless.service';
import { ForgeIconModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { BreadcrumbComponent } from "xng-breadcrumb";
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  standalone: true,
  imports: [
    RouterOutlet,
    ForgeToolbarModule,
    BreadcrumbComponent,
    ForgeIconModule,
    AsyncPipe,
    NgIf
  ],
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {
  public chromeless$ = this.chromelessService.chromeless$;

  constructor(private chromelessService: ChromelessService) {}
}